import React from 'react';
import './History.css';
import useReveal from '../hooks/useReveal';
import { history, aims } from '../data/schoolData';

export function History() {
  const hRef = useReveal();
  return (
    <section className="section history-section" id="history">
      <div className="container">
        <div className="section-head center reveal" ref={hRef}>
          <span className="stag">Our Journey</span>
          <h2 className="stitle">History of the School</h2>
          <div className="sline center" />
        </div>
        <div className="timeline">
          {history.map(item => {
            const ref = useReveal(); // eslint-disable-line
            return (
              <div key={item.year} className="tl-item reveal" ref={ref}>
                <div className="tl-dot"><span>{item.year}</span></div>
                <div className="tl-box">
                  <div className="tl-yr">{item.year} · {item.phase}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function Motto() {
  const ref = useReveal();
  return (
    <section className="motto-section" id="motto">
      <div className="container">
        <div className="section-head center reveal">
          <span className="stag" style={{ color: 'rgba(255,255,255,.55)' }}>Core Values</span>
          <h2 className="stitle" style={{ color: 'white' }}>The St. Xavier's Motto</h2>
        </div>
        <div className="motto-words reveal" ref={ref}>
          {['Sacrifice', 'Love', 'Service'].map((word, i) => (
            <React.Fragment key={word}>
              {i > 0 && <span className="mw-sep">·</span>}
              <div className="mw">
                <div className="mw-t">{word}</div>
                <div className="mw-s">
                  {word === 'Sacrifice' ? 'Give without reservation' :
                   word === 'Love'      ? 'Care for every soul' : 'Act with purpose'}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
        <p className="motto-q reveal">
          "Our motto sums up very briefly the vision of our school — to enable our students
          to be lights of the world through their day to day life at home, in the school,
          in the neighborhood and wherever they go."
        </p>
      </div>
    </section>
  );
}

export function Aims() {
  const hRef = useReveal();
  return (
    <section className="section aims-section" id="aims">
      <div className="container">
        <div className="section-head center reveal" ref={hRef}>
          <span className="stag">Purpose & Mission</span>
          <h2 className="stitle">Aims & Objectives</h2>
          <div className="sline center" />
        </div>
        <div className="aims-grid">
          {aims.map(a => {
            const ref = useReveal(); // eslint-disable-line
            return (
              <div key={a.num} className="aim-card reveal" ref={ref}>
                <div className="aim-n">{a.num}</div>
                <h3>{a.title}</h3>
                <p>{a.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
